import * as i18next from 'i18next';

import { AppLanguageHelper } from './utils/AppLanguageHelper';
import { Hooks } from './utils/Hooks';
import { Application, RELEASE_COMMIT } from './App';

// Submodules
import { enterFullscreen, setDarkStatusbar } from './submodules/app-api/AppAction';

import utils = egr.wcf.utils;
import { getEnvVar } from './submodules/utils/ReactScriptHelper';
import { AppDispatcher } from './dispatcher/AppDispatcher';
import { registerLogHandler, BaseMessage } from './submodules/app-api/Communication';
import { initializeAppInfo } from './submodules/app-api/Information';
import { createConsoleOverlay } from './submodules/utils/Debug';

declare global {
    interface Window {
        TestApp: Application | undefined;
        _log_args: () => void;
        ReactNativeWebView?: {
            postMessage: (data: string) => void;
        };
    }

    interface JQuery {
        scrollbar: (parameter: any) => void;
        scrollTop: (parameter?: any) => any;
        scroll: () => void;
        find: (parameter?: any) => any;
        hasClass: (name: string) => boolean;
        fadeTo: (arg1: string | number, arg2: number, cb: any) => any;
        length: any;
    }

    interface JQueryAjaxSettings {}

    interface JQueryXHR {}

    interface JQueryEventObject {}
}

window._log_args = function _log_args(): void {
    // tslint:disable-next-line:no-console
    console.log(Array.prototype.slice.call(arguments));
};

if (utils.string.isNotNullOrEmpty(getEnvVar('DEBUG_CONSOLE_OVERLAY'))) {
    createConsoleOverlay(2500);
}

if (utils.string.isNotNullOrEmpty(getEnvVar('DEBUG_DISPATCHER_ACTIONS'))) {
    AppDispatcher.register((payload: any): void => {
        // tslint:disable-next-line:no-console
        console.log({
            type: 'dispatcher',
            payload
        });
    });
}

if (utils.string.isNotNullOrEmpty(getEnvVar('DEBUG_APP_COMMUNICATION', ''))) {
    registerLogHandler((msg: BaseMessage): void => {
        // tslint:disable-next-line:no-console
        console.log(msg);
    });
}

const onloadPromise: Promise<void> = new Promise((resolve, reject) => { (window as any).onload = resolve; });

export let i18n: i18next.i18n;

(async (): Promise<void> => {
    await initializeAppInfo();
    setDarkStatusbar();

    let translationPromise: Promise<{lng: string, res?: any}>;

    const fallbackTranslation: {lng: string} = {lng: 'en'};
    const userLang: string | null = AppLanguageHelper.getValidLanguage();

    if (userLang != null) {
        translationPromise = new Promise((resolve, reject) => {
            jQuery.ajax({
                url: 'i18n/' + userLang + '/translation.json?' + RELEASE_COMMIT,
                dataType: 'json'
            }).done((data) => { resolve({lng: userLang, res: data}); }
            ).fail(() => {
                resolve(fallbackTranslation);
            });
        });
    } else {
        translationPromise = Promise.resolve(fallbackTranslation);
    }

    // toLocaleString polyfill (for currency and date converstion)
    const supportsToLocaleStringOptions: boolean = !!(typeof Intl === 'object' && Intl && typeof Intl.NumberFormat === 'function');

    let toLocaleStringPolyfillPromise: Promise<void>;

    if (!supportsToLocaleStringOptions) {
        toLocaleStringPolyfillPromise = new Promise((resolve, reject) => {
            jQuery.ajax({
                url: 'scripts/intl/Intl.min.js',
                dataType: 'script'
            }).done(() => {
                jQuery.ajax({
                    url: `scripts/intl/locale-data/${userLang}.js'`,
                    dataType: 'script'
                }).done(() => { resolve(); }).fail(() => { resolve(); });
            }).fail(() => {
                jQuery.ajax({
                    url: 'scripts/intl/locale-data/en.js',
                    dataType: 'script'
                }).done(() => { resolve(); }).fail(() => { resolve(); });
            });
        });
    } else {
        toLocaleStringPolyfillPromise = Promise.resolve();
    }

    await Promise.all([
        enterFullscreen(),
        onloadPromise,
        toLocaleStringPolyfillPromise,
        translationPromise.then((settings) => {
            return new Promise((resolve, reject) => {
                const mapping: {} = {};
                if (settings.res != null) {
                    mapping[settings.lng] = {
                        translation: settings.res
                    };
                }

                i18n = i18next.init(
                    {
                        lng: settings.lng,
                        resources: mapping,
                        returnEmptyString: false,
                        nsSeparator: '',
                        keySeparator: ''
                    },
                    resolve as any
                );
            });
        }),
        Hooks.preAppInstantiationHook()
    ]);

    window.TestApp = new Application();
})();


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx